import type { EmployeeCalendarDay } from "@/lib/employeeCalendar";
import {
  calendarDayClassName,
  calendarDayTitle,
  formatCalendarDayShort,
} from "@/lib/employeeCalendar";

export function CalendarDayBadge({ day }: { day: EmployeeCalendarDay }) {
  return (
    <span
      className={`inline-flex max-w-full truncate rounded-md px-1 py-px text-[9px] font-bold leading-none ${calendarDayClassName(day)}`}
      title={calendarDayTitle(day)}
    >
      {day.kind === "holiday" ? "FT" : formatCalendarDayShort(day)}
    </span>
  );
}

export function CalendarDayBadges({ days }: { days: EmployeeCalendarDay[] }) {
  if (!days.length) return null;
  return (
    <div className="flex flex-wrap justify-center gap-0.5">
      {days.map((day) => (
        <CalendarDayBadge key={`${day.work_date}-${day.kind}`} day={day} />
      ))}
    </div>
  );
}
